import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { Me } from './types';

export const meQueryKey = ['me'] as const;

/** Единственный запрос на старте: он решает, какое приложение показать. */
export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: () => api.get<Me>('/api/me'),
    staleTime: 60_000,
  });
}
